// extracted by mini-css-extract-plugin
export default {"displayContainer":"RequestDisplay_displayContainer__yERKi","copyIcon":"RequestDisplay_copyIcon__o3vaP"};